export default __webpack_public_path__ + "static/media/couple-planning-for-retirement.af7126e3.svg";